export var webInfoHzyc = {
    id: 'hzyc',
    webName: '惠智云采',
    webFullName: '惠智云采',
    iconUrl: '/favicon-hzyc.ico',
    logoUrl: 'http://www.zhbykj.com/logos/hzyc/logo.png',
    mobile: '400-901-6886',
    themeColor: '#a32625',
    citycode: "0",
    planname:'hzc',     // 平台内标识
    
    loginUrl: 'http://web.smartprocure.cn/biddingWeb/pages/chooseusersub.html?indexUrl=aHR0cDovL3dlYi5zbWFydHByb2N1cmUuY24v&title=%u60E0%u667A%u91C7%u667A%u80FD%u91C7%u8D2D%u7EFC%u5408%u7BA1%u7406%u5E73%u53F0&plan=hzc',
    signUrl: 'http://web.smartprocure.cn/register/',

    home: {
        banner: [
            {
                text1: '1个目标',
                text2: '致力于高效采购、智慧管理，智能采购综合管理平台，轻松搞定采购',
                btn: true,
                itemBg:'/images/hzyc/home/banner-bg.png',
                textPos: { marginLeft: `-600px`, marginTop: '-170px' },
                textSize: { height: '100px' },
                animate: 'animate__flipInX',
                animateController: false,
            },
        ],
        gxzcList: [
            {
                img: '/images/hzyc/home/gxcg1.png',
                title: '一站式电子招标采购',
                text: '支持九大采购模式，根据项目不同，灵活切换模式。',
            },
            {
                img: '/images/hzyc/home/gxcg2.png',
                title: '供应商及专家智能管理',
                text: '建立优质供应商及专家库，进行全流程把控智能分级， 多种寻源方式，轻松比价定价。',
            },
            {
                img: '/images/hzyc/home/gxcg3.png',
                title: '内外协同强势增效',
                text: '实现外部内部全角色协作，多节点流转，大幅度提升工作效率。',
            },
            {
                img: '/images/hzyc/home/gxcg4.png',
                title: '监管透明合规',
                text: '系统全程留痕，与监管平台对接，整个过程公开透明。',
            },
        ],
        zhglList: [],
        jjfaBg: '/images/hzyc/home/qcj-bg.png', //全场景解决方案
        ptlc: '/images/hzyc/home/liucheng.png',    //平台流程
        kjfnLsit: [
            {
                title: '智能化赋能  系统随时响应',
                text: '随时修改、随时发布，在快速发展的业务中游刃有余，业务增长迫在眉睫，但系统早已准备就绪',
                img: '/images/hzyc/home/tec/1.png',
            },
            {
                title: '互联网+赋能  协同更便捷',
                text: '互联网+覆盖采购全流程，协同每个角色及节点，平台快速响应业务变化',
                img: '/images/hzc/home/tec/2.png',
            },
            {
                title: '数字化赋能  精准决策',
                text: '基于大数据和算法，智能建模，精准把控采购决策，平台响应每个业务',
                img: '/images/hzc/home/tec/3.png',
            },
        ],
    },
    footer: {
        row1: {
            title: '相关网站',
            list: [
                { url: 'http://www.zchrkj.com/pages/zhaobiaocaigou.html', name: '招标采购交易平台' },
                { url: 'http://www.zchrkj.com/pages/baohanbanli.html', name: '保函办理平台' },
                { url: 'http://www.zchrkj.com/pages/zhuanjiaguanli.html', name: '专家管理平台' },
                { url: 'http://www.zchrkj.com/pages/xianshangpeixun.html', name: '线上培训平台' },
                { url: 'http://www.zchrkj.com/pages/yunzixun.html', name: '云咨询服务平台' },
            ],
        },
        row2: {
            title: '联系我们',
            list: [
                '联系电话：400-901-6886',
                // '邮箱：zhkj@qq.com',
                '地址: 北京市海淀区城西路辅路莲花苑5号 华宝大厦',
            ],
        },


        company: '中财惠瑞（北京）科技发展有限公司',
        companyUrl: "http://www.zchrkj.com/index.html",
        ICP: '京ICP备2020039654号-12',
        ICPUrl: "",
        // copyright: '',
        // copyrightUrl: '',

        QRCodeList: [
            {
                url: '/images/hzyc/qrcode.jpg',
                name: '惠智云采微信公众号',
            },
        ],
    },
    //关于我们
    about:{
        qyjs:{
            showLeftVideo: false,
            title:'中财惠瑞（北京）科技发展有限公司',
            rightList:[
                '中财惠瑞（北京）科技发展有限公司深耕工程建设领域20余年，一直致力于为政府机关、建设单位、公共资源、监督机构、评标专家、招标代理、投标单位、工程咨询单位等相关方提供从规划咨询、平台搭建、实施交付到运营维护等全方位服务。',
                '数字经济时代的到来进一步促进了招标采购向数智化发展的转变。中财惠瑞利用新一代信息技术，通过构建数据的采集、传输、存储、处理和反馈的闭环，打通不同层级与行业间的数据壁垒，促进整个供应链提质增效，用全新的数字经济体系让招标采购更有深度、政府监管更有力度、数据共享更有广度。',
                '作为行业前沿的探索者与领航者，中财惠瑞正在与各方合作伙伴携手共同营造产业新生态，开创招采新时代！',
            ],

        },

        // 荣誉资质
        ryzz:[],
        //企业风采
        qyfc:[],

        //联系我们
        lxwm: {
            mobile: "固定电话：010-63995771",
            address: '地址: 北京市海淀区城西路辅路莲花苑5号 华宝大厦',
            mapPosition: {
                lng: 116.315057, 
                lat: 39.901767,
            },
        },

        //相关下载
        xgxz: [],

    },

    // 侧边栏
    onlineServe: [
        {
            isPopover: false,
            disabled: false,     //是否 禁用弹窗
            imgUrl: '/images/hzyc/consult/1.png',
            text: '电话咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzyc/consult/2.png',
            text: '在线咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzyc/consult/3.png',
            text: '测试使用',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzyc/consult/4.png',
            text: '微信咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
    ],
};
